//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    getTotal(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.runs.total).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
    getBlockedDates(vue, cb, errorCb, finallyCb) {
        axios.get(window.kgkRoutes.runs.getBlockedDates).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    create(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.runs.create, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    get(vue, runIdentifier, cb, errorCb, finallyCb) {
        // should be GET but ...
        axios.post(window.kgkRoutes.runs.details, { identifier: runIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    update(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.runs.update, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    delete(vue, runIdentifier, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.runs.delete, { identifier: runIdentifier }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
